import 'angular:locale/data:tr';
import 'angular:locale/data:en';
import 'angular:locale/data:de';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
